/* eslint-disable camelcase */
export const MEMBER_SEAECH_TABLE_COL = [
  {
    displayName: "ID",
    key: "id",
  },
  {
    displayName: "Member Name & Address",
    key: ["memberName", "memberAddress"],
  },
  {
    displayName: "Phone & Email",
    key: ["phone", "email"],
  },
  {
    displayName: "Division",
    key: "division",
  },
  {
    displayName: "Organization Structure",
    key: "organizationStructure",
  },
  {
    displayName: "Status",
    key: "status",
  },
  {
    displayName: "Action",
    key: "action",
  },
];

export const ROLE_MEMBER_SEAECH_TABLE_COL = [
  {
    displayName: "ID",
    key: "id",
  },
  {
    displayName: "Member Name",
    key: ["memberName"],
  },
  {
    displayName: "Division",
    key: ["divisionName"],
  },
  {
    displayName: "Organizational Structure",
    key: "organizationalStructure",
  },
  {
    displayName: "Role",
    key: "role",
  },
  {
    displayName: "Status",
    key: "status",
  },
  {
    displayName: "Action",
    key: "action",
  },
];

export const PROXY_ROLE_MEMBER_SEAECH_TABLE_COL = [
  {
    displayName: "ID",
    key: "id",
  },
  {
    displayName: "Member Name",
    key: ["memberName"],
  },
  {
    displayName: "Division",
    key: ["divisionName"],
  },
  {
    displayName: "Organizational Structure",
    key: "organizationalStructure",
  },
  {
    displayName: "Role",
    key: "role",
  },
  { displayName: "Proxy Role", key: "proxyRoles" },
  {
    displayName: "Status",
    key: "status",
  },
  {
    displayName: "Action",
    key: "action",
  },
];

export const PERMISSIONS_SEAECH_TABLE_COL = [
  {
    displayName: "Name",
    key: ["roleName"],
  },
  {
    displayName: "Updated By",
    key: "updatedBy",
  },
  {
    displayName: "Updated At",
    key: "updatedAt",
  },
  {
    displayName: "Action",
    key: "action",
  },
];

export const MEMBER_SEARCH_COL = [
  "memberId",
  "fullName",
  "emailId",
  "mobileNumber",
  "addressLine1",
  "addressLine2",
  "city",
  "pincode",
  "state",
  "nationalityId",
  "divisionId",
  "divisionName",
  "subdivisionId",
  "subDivisionName",
  "introducedBy",
  "areaId",
  "areaName",
  "zoneId",
  "zoneName",
  "regionId",
  "regionName",
  "chapterId",
  "chapterName",
  "districtId",
  "districtName",
  "blockId",
  "blockName",
  "introducerName",
  "introducerEmail",
  "introducerMobileNumber",
];
export const EXAM_MEMBER_SEAECH_TABLE_COL = [
  {
    displayName: "ID",
    key: "id",
  },
  {
    displayName: "Member Name & Address",
    key: ["memberName", "memberAddress"],
  },
  {
    displayName: "Phone & Email",
    key: ["phone", "email"],
  },
  {
    displayName: "Division",
    key: "division",
  },
  {
    displayName: "Area",
    key: "area",
  },
  {
    displayName: "Zone",
    key: "zone",
  },
  {
    displayName: "Region",
    key: "region",
  },
  {
    displayName: "Chapter",
    key: "chapter",
  },
  {
    displayName: "District",
    key: "district",
  },
  {
    displayName: "Block",
    key: "block",
  },
  // {
  //   displayName: "Action",
  //   key: "action",
  // },
];

export const EXAM_APPLIED_MEMBER_SEAECH_TABLE_COL = [
  {
    displayName: "Member/ Friend ID",
    key: "id",
  },
  {
    displayName: "Type",
    key: "type",
  },
  {
    displayName: "Roll Number",
    key: "rollNumber",
  },
  {
    displayName: "Applicant Name",
    key: ["applicantName"],
  },
  {
    displayName: "Phone",
    key: ["phone"],
  },
  {
    displayName: "Division",
    key: "division",
  },
  {
    displayName: "Organization Structure",
    key: "organization_structure",
  },
  // {
  //   displayName: "Area",
  //   key: "area",
  // },
  // {
  //   displayName: "Zone",
  //   key: "zone",
  // },
  // {
  //   displayName: "Region",
  //   key: "region",
  // },
  // {
  //   displayName: "Chapter",
  //   key: "chapter",
  // },
  // {
  //   displayName: "District",
  //   key: "district",
  // },
  // {
  //   displayName: "Block",
  //   key: "block",
  // },
];

export const EXAM_APPLIED_MEMBER_SEAECH_TABLE_COL_OTHER_THAN_ENTRANCE = [
  {
    displayName: "ID",
    key: "id",
  },
  {
    displayName: "Roll Number",
    key: "rollNumber",
  },
  {
    displayName: "Member Name & Address",
    key: ["memberName", "memberAddress"],
  },
  {
    displayName: "Phone & Email",
    key: ["phone", "email"],
  },
  {
    displayName: "Division",
    key: "division",
  },
  {
    displayName: "Organization Structure",
    key: "organization_structure",
  },
];

export const EXAM_RESULT_MEMBER_SEAECH_TABLE_COL_OTHER_THAN_INTERMEDIATE = [
  {
    displayName: "ID",
    key: "id",
  },
  {
    displayName: "Roll Number",
    key: "rollNumber",
  },
  {
    displayName: "Member Name",
    key: ["memberName", "memberAddress"],
  },
  // {
  //   displayName: "Phone",
  //   key: ["phone", "email"],
  // },
  {
    displayName: "Division",
    key: "division",
  },
  {
    displayName: "Organization Structure",
    key: "organization_structure",
  },
  {
    displayName: "Result",
    key: "status",
  },
];
